/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {  makeStyles } from '@material-ui/core/styles';
import { object } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { useUIDSeed } from 'react-uid';
import DesktopMobile from '../../../helpers/DesktopMobile/DesktopMobile';
import LinkOrATag from './LinkOrATag/LinkOrATag';

const useStyles = makeStyles((theme) => ({
    subnavDesktop: {
        width: '100%',
        margin: '-37px auto 20px auto',
        display: 'flex',
        boxSizing: 'border-box',
        backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        [theme?.breakpoints?.up(1400)]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
        '@media screen and (min-width: 768px) and (max-width: 1300px)': {
            flexWrap: 'wrap',
            height: 'auto',
        },
        '@media screen and (min-width: 768px) and (max-width: 1023px)': {
            margin: '-22px auto 20px auto',
        },
    },
    subnavTitleDesktop: {
        textDecoration: 'none',
        flex: '1 1 auto',
        height: '100%',
        boxSizing: 'border-box',
        fontSize: 14,
        textAlign: 'center',
        padding: '14px 0px',
        color: theme?.palette?.colorPrimaryContrast,
        transition: 'background-color 0.23s ease-out',

        '@media screen and (min-width: 768px) and (max-width: 1300px)': {
            margin: '0 3px 2px 0',
        },
        '&:last-child': {
            '& span': {
                borderRight: 0,
            },
        },
        '& span': {
            borderRight: '1px solid',
            display: 'block',
        },
    },
    subnavCollectionMobile: {
        width: '100%',
        margin: '0 auto 25px auto',
    },
    subnavCollectionTitleMobile: {
        [theme?.breakpoints?.down(767)]: {
            minHeight: '62px',
            fontSize: 18,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            lineHeight: '20px',
            fontWeight: 'normal',
            backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
            color: theme?.palette?.colorPrimaryContrast,
            border: `1px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
            borderRadius: '2px',
            textAlign: 'center',
            textDecoration: 'none',
        },
    },
    subnavCollectionImageMobile: {
        width: 35,
        height: 35,
    },
}));

const SubNavigation = ({
    subnavBlock,
}) => {
    const classes = useStyles();
    const seed = useUIDSeed();
    const getBlock = (navLink, linkStyle = {}) => (
        <LinkOrATag
            id={navLink.link?.title.split(' ').join('-').toLowerCase()}
            dataTest="collection-sub-nav-mobile"
            name="collectionSubNavMenuMobile"
            className={classes.subnavCollectionTitleMobile}
            href={navLink?.link?.href}
            key={navLink?.link?.title}
            style={linkStyle}
        >
            { navLink?.mobile_image?.url &&  <img  className={classes.subnavCollectionImageMobile} src={navLink?.mobile_image?.url} alt={navLink?.link?.title} />}
            {navLink.link?.title}
        </LinkOrATag>
    );

    if (subnavBlock && subnavBlock?.sub_navigation_group) {
        return (
            <DesktopMobile
                desktop={() => (
                    <div className={classes.subnavDesktop}>
                        {subnavBlock?.sub_navigation_group?.map((navLink) => (
                            <LinkOrATag
                                id={navLink.link?.title.split(' ').join('-').toLowerCase()}
                                name="collectionSubNavMenuDesktop"
                                className={classes.subnavTitleDesktop}
                                href={navLink?.link?.href}
                                key={seed(navLink)}
                                style={{
                                    backgroundColor: `${navLink?.background_color}`,
                                    color: `${navLink?.text_color}`,
                                }}
                            >
                                <span> {navLink.link?.title}</span>
                            </LinkOrATag>
                        ))}
                    </div>
                )}
                mobile={() => (
                    <Grid container spacing={1} className={classes.subnavCollectionMobile}>
                        {    subnavBlock?.sub_navigation_group?.map((navLink) => {
                            const linkStyle =   {
                                backgroundColor: `${navLink?.background_color}`,
                                color: `${navLink?.text_color}`,
                            };
                            return (
                                <Grid key={seed(navLink)} item xs={12}>
                                    {getBlock(navLink, linkStyle)}
                                </Grid>
                            );
                        })}
                    </Grid>
                )}
                breakpoint={767}
            />
        );
    }

    return null;
};

SubNavigation.propTypes = {
    subnavBlock: object.isRequired,
};

export default SubNavigation;
